import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
//import "./Special/special.css";
import Button from 'react-bootstrap/Button';
import PlayerCommentDisplayCard from './player_comment_display_card';


class PlayerCommentActionRequiredModal extends Component {
  constructor(props) {
    super(props);
    this.state={
      
      }    
    this.commentArr = [];
    this.selectComments();
}

selectComments(){
    for (let i=0; i<this.props.playerFeedback.length; i++){
        const playerComment = this.props.playerFeedback[i];
        if (this.props.reviewCodeArr.includes(playerComment.reviewed.code)){
            this.commentArr.push(playerComment);
        }
    }
}
   
render() {
        this.playerCommentInfo = this.commentArr.map((playerFeedback, index) =>
          <PlayerCommentDisplayCard playerFeedback={playerFeedback}  key={index}  
           commentsOnly={this.props.commentsOnly}
           index={index}/>
              );
        
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="xl" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Action Required Based on Player Comments&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              Number of Comment Records: &nbsp;{this.commentArr.length}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <span>
              <table className="table">
                <tbody>
                  <tr>
                    <th>User</th>
                    <th>Date and Time of Comment</th>
                    <th>Thumb Chosen</th>
                    <th>Comment</th>
                  </tr>
                  {this.playerCommentInfo}
                </tbody>
              </table>
                             
              </span>
                  
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
             
              <Button variant="primary"  onClick={() => this.props.onClose()}>
                   Close
              </Button>
              
        </Modal.Footer>
       
    </Modal>
    
  </>
  }
}

export default PlayerCommentActionRequiredModal;